export const MIN_HEIGHT = 52;
